import { render, staticRenderFns } from "./CatalogProductContentSection.vue?vue&type=template&id=7c5b44ef&scoped=true&"
import script from "./CatalogProductContentSection.vue?vue&type=script&lang=js&"
export * from "./CatalogProductContentSection.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductContentSection.vue?vue&type=style&index=0&id=7c5b44ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5b44ef",
  null
  
)

export default component.exports